// extracted by mini-css-extract-plugin
export default {"menu":"ContextMenu_menu__PU8yQ","menuOverlay":"ContextMenu_menuOverlay__mQKae"};